/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ReactNode } from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	root: {
		display: 'grid',
		gridTemplateColumns: '1fr',
		gap: token('space.200'),
		borderColor: token('color.border'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		paddingBlockStart: token('space.200'),
		paddingInlineEnd: token('space.200'),
		paddingBlockEnd: token('space.200'),
		paddingInlineStart: token('space.200'),
		borderRadius: token('radius.large'),
		'@media (min-width: 48rem)': {
			gridTemplateColumns: '1fr 1fr',
		},
	},
});

interface UICardProps {
	children: ReactNode;
}

export const UICard: ({ children }: UICardProps) => JSX.Element = ({ children }: UICardProps) => {
	return <Box xcss={styles.root}>{children}</Box>;
};
